import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  profiles: [],
  loading: false,
  loadingPage: false,
  error: null,
};

const loadAction = (state, actions) => {
  state.loading = true;
  const pageLoad = actions?.payload?.pageLoad;
  const profileName = actions?.payload?.name;
  state.loadingPage = pageLoad ? true : state.loadingPage;

  if (profileName && !state.profiles.includes(profileName))
    state.profiles = [...state.profiles, profileName];
};

const unloadAction = (state, actions) => {
  const pageLoad = actions?.payload?.pageLoad;
  const profileName = actions?.payload?.name;
  state.loading = false;
  state.loadingPage = pageLoad ? false : state.loadingPage;

  if (profileName && state.profiles.includes(profileName)) {
    const tempProfiles = [...state.profiles];
    const index = tempProfiles.indexOf(profileName);
    if (index > -1) {
      tempProfiles.splice(index, 1);
    }
    state.profiles = [...tempProfiles];
  }
};

export const loadingServiceSlice = createSlice({
  name: "load",
  initialState: initialState,
  reducers: { load: loadAction, unload: unloadAction },
});

export const { load, unload } = loadingServiceSlice.actions;
export default loadingServiceSlice.reducer;
